import { BaseFilterOption } from '../../../FilterResultsManager/options/types';
import { config as impactConfig } from './impact';
import { config as proteinEffectConfig } from './proteinEffect';
import { config as variantDescriptionConfig } from './variantDescription';

export const filterOptions: Array<Partial<BaseFilterOption>> = [
  { ...impactConfig },
  { ...proteinEffectConfig },
  { ...variantDescriptionConfig },
];
